import DatePicker from "react-multi-date-picker";
import { AiOutlineUpload, AiOutlineCloseSquare, AiOutlineSearch, AiOutlineCheckSquare, AiOutlineEdit } from "react-icons/ai";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/colors/red.css";
import { useEffect, useState, useRef } from "react";

export default function AddModal({ addEditContract }) {
  const addForm = useRef(null);

  return (
    <div class="modal fade" id="create-contract" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
      <div class=" modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="createLabel">
              ایجاد قرارداد
            </h5>
            <button type="button" class="btn-close" id="close-add-modal" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form
            ref={addForm}
            onSubmit={(e) => {
              e.preventDefault();
              addEditContract(e, "add");
            }}
          >
            <div class="modal-body d-flex flex-column">
              <div className="mt-3">
                <label htmlFor="senfcode">کد صنفی</label>
                <input type="number" name="senfcode" className="form-control" id="senfcode" />
              </div>
              <div className="mt-3">
                <label htmlFor="fullname">نام</label>
                <input type="text" name="fullname" className="form-control" id="fullname" />
              </div>
              <div className="mt-3">
                <label htmlFor="amlakname">نام املاک</label>
                <input type="text" className="form-control" name="amlakname" id="amlakname" />
              </div>

              <div className="mt-3">
                <label htmlFor="tell">تلفن املاک </label>
                <input type="number" className="form-control" name="tell" id="tell" />
              </div>
              <div className="mt-3">
                <label htmlFor="mobile">موبایل املاک </label>
                <input type="number" className="form-control" name="mobile" id="mobile" />
              </div>

              <div className="mt-3">
                <label htmlFor="mainmobile">شماره تماس </label>
                <input type="number" className="form-control" name="mainmobile" id="mainmobile" />
              </div>

              <div className="mt-3 w-100" style={{ width: "100%" }}>
                <label htmlFor="expire_date">تاریخ پایان</label>
                <div>
                  <DatePicker className="red" style={{ padding: "15px 10px", width: "100%" }} calendar={persian} locale={persian_fa} calendarPosition="bottom-right" name="expire_date" />
                </div>
              </div>

              <div className="mt-3">
                <label htmlFor="sms_request_count">تعداد درخواست پیامک</label>
                <input type="number" className="form-control" id="sms_request_count" name="sms_request_count" />
              </div>

              <div class="form-check form-switch mt-3">
                <label class="form-check-label" for="amlak_state">
                  وضعیت املاک
                </label>
                <input class="form-check-input" name="amlak_state" type="checkbox" id="amlak_state" />
              </div>

              <div class="form-check form-switch mt-3">
                <label class="form-check-label" for="amlak_subscription_state">
                  وضعیت اشتراک
                </label>
                <input class="form-check-input" type="checkbox" id="amlak_subscription_state" name="amlak_subscription_state" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                بستن
              </button>
              <button type="submit" class="btn btn-primary">
                اضافه
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
